import { call, put, takeLatest } from 'redux-saga/effects'
import type { PayloadAction } from '@reduxjs/toolkit'
import { httpsCallable } from 'firebase/functions'
import { functions } from '@/lib/firebase'
import type { AdminMetrics } from './adminSlice'
import {
    fetchAdminMetricsSaga,
    setAdminLoading,
    setAdminMetrics,
    setAdminError,
    setAdminForbidden,
} from './adminSlice'

function* fetchAdminMetricsWorker(action: PayloadAction<number | undefined>): Generator<any, void, any> {
    yield put(setAdminLoading(true))
    yield put(setAdminForbidden(false))
    yield put(setAdminError(null))
    try {
        const fn = httpsCallable<{ months?: number }, AdminMetrics>(functions, 'getAdminMetrics')
        const result: { data: AdminMetrics } = yield call(() => fn({ months: action.payload }))
        yield put(setAdminMetrics(result.data))
    } catch (error: any) {
        // A non-admin caller surfaces as the callable-wrapped code `functions/permission-denied`
        // (the `functions/` prefix distinguishes it from a raw Firestore permission error).
        if (error?.code === 'functions/permission-denied') {
            yield put(setAdminForbidden(true))
        } else {
            yield put(setAdminError(error?.message ?? 'Failed to load metrics'))
        }
    } finally {
        yield put(setAdminLoading(false))
    }
}

export function* watchAdminSaga() {
    yield takeLatest(fetchAdminMetricsSaga.type, fetchAdminMetricsWorker)
}
